import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import React, { FunctionComponent } from 'react';
import { useTranslation } from '../../../../../hooks/useTranslation';
import { PageTextContentType } from '../../../../../hooks/useContentMgmt';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import TextLink from '../../../../text-link';
import useDownloadBill from '../../../../../hooks/useDownloadBill';
import useWrapWithLoader from '../../../../../hooks/useWrapWithLoading';

interface Props {
  accountNumber: string;
  partialAddress: string;
  projectNum: string;
  content: PageTextContentType;
  encryptedBillId: string;
}

const GuestPaymentHeaderSection: FunctionComponent<Props> = props => {
  const { t } = useTranslation();
  const { content } = props;
  const downloader = useDownloadBill();
  const { wrapWithLoader } = useWrapWithLoader();
    
  const downloadBill = wrapWithLoader(
    async (encryptedBillId: string) => {
      if (encryptedBillId) {
        const billId = encryptedBillId;

        const linkSource = await downloader.downloadBill(billId, false, false);
        const downloadLink = document.createElement('a');

        downloadLink.href = linkSource;
        downloadLink.download = `${content
          .get('VIEW_BILL')!
          .replace(' ', '_')}-${Date.now()}.pdf`;
        downloadLink.click();
      }
    },
    () => content.get('NO_BILL_FOUND')!,
  );

  return (
    <Paper style={{ boxShadow: 'none' }}>
      <CardContent>
        <Grid
          container
          spacing={2}
          style={{ display: 'flex', flexDirection: 'row' }}
        >
          <Grid item xs={12} md={4}>
            <Grid item xs={12}>
              <Typography variant={'body2'}>{content.get('BILL_ID')}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant={'subtitle2'}>
                {props?.accountNumber}
              </Typography>
              <PictureAsPdf
                          style={{ marginRight: 4, fontSize: 12 }}
                        />
                        <TextLink
                          style={{
                            textDecoration: 'underline',
                            marginRight: '10px',
                            fontSize: '12px',
                            display: 'inline-block',
                          }}
                          onClick={async (e: any) => {
                            e.preventDefault();
                            await downloadBill(props?.encryptedBillId || '');
                          }}
                        >
                          {content.get('DOWNLOAD_PDF')}
                        </TextLink>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid item xs={12}>
              <Typography variant={'body2'}>{content.get('PROJECT_NUMBER')}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant={'subtitle2'}>{props?.projectNum}</Typography>
            </Grid>
          </Grid>
        
          <Grid item xs={12} md={4}>
            <Grid item xs={12}>
              <Typography variant={'body2'}>
                {content.get('PROJECT_ADDRESS')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant={'subtitle2'}>
                {props?.partialAddress}
              </Typography>
            </Grid>
          </Grid>
          </Grid>
      </CardContent>
    </Paper>
  );
};

export default GuestPaymentHeaderSection;
